var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileImgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_190_63317)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "black",
    fillOpacity: 0.33
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_190_63317)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_190_63317",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 21H21V45H45V21Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_190_63317)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.25 22H32.217C30.612 22 29.363 22 28.359 22.08C27.4627 22.1158 26.5817 22.325 25.765 22.696C24.432 23.3532 23.3532 24.432 22.696 25.765C22.3247 26.5837 22.1155 27.4667 22.08 28.365C22 29.365 22 30.617 22 32.222V32.793C22 34.63 22 36.06 22.1 37.203C22.1471 38.2258 22.4204 39.2254 22.9 40.13C23.4926 41.1559 24.3448 42.0078 25.371 42.6C26.2755 43.08 27.2752 43.3532 28.298 43.4C29.441 43.5 30.871 43.5 32.708 43.5H33.279C34.884 43.5 36.133 43.5 37.136 43.42C38.0327 43.3843 38.914 43.1752 39.731 42.804C41.064 42.1468 42.1428 41.068 42.8 39.735C43.1707 38.9178 43.3799 38.0366 43.416 37.14C43.496 36.14 43.496 34.888 43.496 33.283V32.75C43.496 32.5511 43.417 32.3603 43.2763 32.2197C43.1357 32.079 42.9449 32 42.746 32C42.5471 32 42.3563 32.079 42.2157 32.2197C42.075 32.3603 41.996 32.5511 41.996 32.75V33.25C41.996 34.895 41.996 36.085 41.921 37.022V37.05L41.884 37.013C41.3684 36.4703 40.82 35.9597 40.242 35.484C39.7725 35.0816 39.18 34.8509 38.562 34.83C37.9441 34.8513 37.3517 35.0819 36.882 35.484C36.3042 35.9603 35.7559 36.4713 35.24 37.014L35.228 37.025L33.1 34.957L33.063 34.921C32.5461 34.393 31.9974 33.8971 31.42 33.436C30.9498 33.0448 30.3615 32.8235 29.75 32.808C29.1392 32.8331 28.5546 33.0627 28.09 33.46C27.5196 33.9297 26.9786 34.434 26.47 34.97L26.433 35.007L23.682 37.757C23.646 37.5263 23.6177 37.2947 23.597 37.062C23.497 35.995 23.497 34.633 23.497 32.75V32.25C23.497 30.605 23.497 29.415 23.572 28.478C23.5949 27.7712 23.7531 27.0753 24.038 26.428C24.55 25.3908 25.3901 24.5517 26.428 24.041C27.0751 23.7556 27.7711 23.5974 28.478 23.575C29.415 23.501 30.605 23.5 32.25 23.5H32.75C32.9489 23.5 33.1397 23.421 33.2803 23.2803C33.421 23.1397 33.5 22.9489 33.5 22.75C33.5 22.5511 33.421 22.3603 33.2803 22.2197C33.1397 22.079 32.9489 22 32.75 22H32.25ZM39.5 23.75C39.5 23.5511 39.421 23.3603 39.2803 23.2197C39.1397 23.079 38.9489 23 38.75 23C38.5511 23 38.3603 23.079 38.2197 23.2197C38.079 23.3603 38 23.5511 38 23.75V26H35.75C35.5511 26 35.3603 26.079 35.2197 26.2197C35.079 26.3603 35 26.5511 35 26.75C35 26.9489 35.079 27.1397 35.2197 27.2803C35.3603 27.421 35.5511 27.5 35.75 27.5H38V29.75C38 29.9489 38.079 30.1397 38.2197 30.2803C38.3603 30.421 38.5511 30.5 38.75 30.5C38.9489 30.5 39.1397 30.421 39.2803 30.2803C39.421 30.1397 39.5 29.9489 39.5 29.75V27.5H41.75C41.9489 27.5 42.1397 27.421 42.2803 27.2803C42.421 27.1397 42.5 26.9489 42.5 26.75C42.5 26.5511 42.421 26.3603 42.2803 26.2197C42.1397 26.079 41.9489 26 41.75 26H39.5V23.75Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_190_63317",
    x: -30,
    y: -30,
    width: 126,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_190_63317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_190_63317",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_63317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(21 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImgIcon);
export default __webpack_public_path__ + "static/media/profile-img-icon.4f7f19e99600526e23ef31da7de01ed8.svg";
export { ForwardRef as ReactComponent };